import type { IUserStore } from '~/modules/main'

export const state = (): IUserStore => {
  return {
    data: null,
    coins: 0,
    isBot: false,
    isAuthorized: false,
    viewGUID: null,
    externalData: {},
    freeSpin: false,
    hasHandledInitialUserModals: false,
  }
}
